import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
// import dict from './modules/dict'
import user from './modules/user'
import tagsView from './modules/tagsView'
import permission from './modules/permission'
import settings from './modules/settings'
import printer from './modules/printer'
import getters from './getters'
import common from "./modules/common";
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        destinationWarehouseMap: {
            '1': 'BR01[巴西一号仓]',
        },
        transferWarehouseMap: {
            '1': 'SZW[深圳中转仓]',
        },
        transferProductMap: {
            '1': 'TCHY[头程海运]',
        },
        receivingTypeMap: {
            '1': '中转代发',
            '2': '自发头程'
        },
        deliveryWarehouseMap: {
            '1': 'SZW[深圳中转仓]',
            '2': 'BR01[巴西一号仓]',
        },
        deliveryMethodMap: {
            '1': '自送',
            '2': '揽收'
        },
        logisticsProductMap: {
            '1': 'TCHY[头程海运]',
        },
    },
    modules: {
        app,
        // dict,
        user,
        tagsView,
        permission,
        settings,
        printer,
        common
    },
    getters
})

store.dispatch('printer/loadSettings')

export default store


// 以下原来的

// import Vue from "vue";
// import Vuex from 'vuex'
//
// Vue.use(Vuex)
//
// const store=new Vuex.Store({
//     state:{
//         currentPathName:''
//     },
//     mutations:{
//         setPath(state){
//             state.currentPathName=localStorage.getItem("currentPathName")
//         }
//     }
// })
// export default store
